import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EncryptDataService } from '../../security/encypt-data.service';

@Injectable({ providedIn: 'root' })
export class TranslateService {
	lang: string = localStorage.getItem('lang') ?? 'en';
	public securityLocalStorage = inject(EncryptDataService);
	private langSubject = new BehaviorSubject<string>(this.lang);
	lang$ = this.langSubject.asObservable();

	constructor() {
		if (!this.lang) {
			const data = localStorage.getItem('data');
			if (data !== null) {
				let dataLocal = JSON.parse(
					this.securityLocalStorage.decryptData(data)
				);
				if (dataLocal !== undefined) {
					this.lang = dataLocal.result.acronym_language.toLocaleLowerCase();
					localStorage.setItem('lang', this.lang);
				} else {
					// localStorage.setItem('lang', 'es');
				}
			} 
			
		}
		this.langSubject.next(this.lang);
	}
	get GetLang(): string {
		if (localStorage.getItem('lang') === 'es') {
			return 'es';
		} else {
			return 'en';
		}
	}
	setLang(lang: string) {
		localStorage.setItem('lang', lang);
		this.lang = lang;
		this.langSubject.next(lang);
	}
	transform(key: string) {
		// const translations = require(`../../../../assets/languaje/${key}.json`);
		// const keys = key.split('.');
		// let translation = translations;
		// for (const k of keys) {
		//     if (translation && translation.hasOwnProperty(k)) {
		//         translation = translation[k];
		//     } else {
		//         return key;
		//     }
		// }
		// return translation;
		return key;
	}
	changeLang() {
		const currentLang = localStorage.getItem('lang');
		let lang = currentLang === 'es' ? 'en' : 'es';
		localStorage.setItem('lang', lang);
		this.lang = lang;
		this.langSubject.next(lang);
	}

	changeLangEs() {
		let lang = 'es';
		localStorage.setItem('lang', lang);
		this.lang = lang;
		this.langSubject.next(lang);
	}

	changeLangEn() {
		let lang = 'en';
		localStorage.setItem('lang', lang);
		this.lang = lang;
		this.langSubject.next(lang);
	}
}
